(() => {
  'use strict';
  if (window.phFacetControlsInstalled) return;
  window.phFacetControlsInstalled = true;
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  function instrument() {
    document.querySelectorAll('details.js-filter').forEach(details => {
      const list = details.querySelector('ul.no-js-hidden, ul.mobile-facets__list');
      if (!list || list.children.length < 10 || details.querySelector('.phb-facet-search')) return;
      const fr = document.documentElement.lang.startsWith('fr');
      const label = (details.querySelector('summary')?.textContent || '').replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim();
      const input = document.createElement('input');
      input.type = 'search'; input.className = 'phb-facet-search'; input.autocomplete = 'off';
      input.placeholder = (fr ? 'Rechercher : ' : 'Search ') + label;
      input.setAttribute('aria-label', input.placeholder);
      const status = document.createElement('div');
      status.className = 'phb-facet-no-results'; status.setAttribute('role','status'); status.hidden = true;
      status.textContent = fr ? 'Aucun résultat' : 'No matches';
      input.addEventListener('input', event => {
        event.stopPropagation();
        const query = normalize(input.value); let matches = 0;
        Array.from(list.children).forEach(item => {
          const match = normalize(item.textContent).includes(query);
          item.hidden = !match; if (match) matches++;
        });
        status.hidden = matches > 0;
      });
      input.addEventListener('keydown', event => { if (event.key === 'Enter') event.preventDefault(); event.stopPropagation(); });
      input.addEventListener('click', event => event.stopPropagation());
      list.before(input, status);
    });
  }
  document.addEventListener('ph:facets:updated', instrument);
  document.addEventListener('shopify:section:load', instrument);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', instrument); else instrument();
})();
